import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  getFreeCancellationPeriodText,
  allCancellationTrans,
} from '~helpers/longtail-cancellation-period';
import FreeCancellationPolicyRule from '~components/longtail-cancellation-policy/rule';
import CheckInTip from '~components/longtail-cancellation-policy/check-in-tip';
import { cancellationPeriodTypeValue } from '~constants/property-field-options';

export default class FreeCancellationPolicy extends React.Component {
  render() {
    const { t, type, value } = this.props;
    const isNonRefundable = type === cancellationPeriodTypeValue.NON_REFUNDABLE;
    const isUntilMoveIn = type === cancellationPeriodTypeValue.UNTIL_MOVE_IN_DAY;
    const isAfterConfirmed = type === cancellationPeriodTypeValue.AFTER_BOOKING_CONFIRMED;
    const content = allCancellationTrans[type] || {};

    const cancellationTitleDesc = (type, value) => {
      if (type === cancellationPeriodTypeValue.NON_REFUNDABLE) {
        return ` - ${t('cms.free_cancellation_policy.title_part.non_refundable')}`;
      }
      if (type === cancellationPeriodTypeValue.UNTIL_MOVE_IN_DAY) {
        return ` - ${t('cms.free_cancellation_policy.title_part.before_move_in_calendar_days_0')}`;
      }
      if (type === cancellationPeriodTypeValue.BEFORE_MOVE_IN) {
        return ` - ${value}${t(
          'cms.free_cancellation_policy.title_part.after_confirmed_calendar_days',
        )}`;
      }
      return '';
    };

    return (
      <div className="longtail-cancellation-policy">
        <h2 className="longtail-cancellation-policy__title">
          {t('cms.free_cancellation_policy.rule')}
          {cancellationTitleDesc(type, value)}
        </h2>
        <div className="longtail-cancellation-policy__container">
          <For of={Object.keys(content)} each="item">
            <If condition={content[item]}>
              <div
                key={item}
                className={classNames('longtail-cancellation-policy__content', {
                  'longtail-cancellation-policy__content--without': item === 'withOut',
                  'longtail-cancellation-policy__content--full': isNonRefundable,
                })}
              >
                <div className="longtail-cancellation-policy__header">
                  <If
                    condition={
                      !(isUntilMoveIn && item === 'withOut') &&
                      !(isAfterConfirmed && item !== 'withOut')
                    }
                  >
                    <h4
                      className={classNames('longtail-cancellation-policy__header-title', {
                        'longtail-cancellation-policy__header-title--after': item === 'withOut',
                      })}
                    >
                      {item === 'withOut'
                        ? getFreeCancellationPeriodText(type, value, t)
                        : t('cms.free_cancellation_policy.booking_paid.title')}
                    </h4>
                  </If>
                </div>
                <FreeCancellationPolicyRule category={item} type={type} />
              </div>
            </If>
          </For>
          <CheckInTip type={type} />
        </div>
      </div>
    );
  }
}

FreeCancellationPolicy.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.string,
  value: PropTypes.number,
};

FreeCancellationPolicy.defaultProps = {
  t: () => {},
  type: '',
  value: null,
};
